'use client'

import { useMemo } from 'react'
import { uniqBy } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { Button } from '@vinted/web-ui'

import { FilterModel } from 'types/models/filter'

import useFetchCatalogBrand from 'pages/Catalog/hooks/useFetchCatalogBrand'

import { initialFilterState, useCatalogContext } from 'pages/Catalog/CatalogProvider'

import { useGetSelectedStaticFilters } from '../../hooks/useGetSelectedStaticFilters'
import useFetchDynamicFilters from '../../hooks/useFetchDynamicFilters'

const FilterReset = () => {
  const fetchDynamicFilters = useFetchDynamicFilters()
  const fetchCatalogBrand = useFetchCatalogBrand()
  const {
    state: { dynamicFilters },
  } = useCatalogContext()
  const { selectedStaticFilters } = useGetSelectedStaticFilters()
  const { selectedDynamicFilters } = dynamicFilters

  const selectedStaticFiltersWithoutQuery = useMemo(() => {
    return uniqBy(selectedStaticFilters, 'name')
      .map(filter => filter.name)
      .filter(name => name !== 'query')
  }, [selectedStaticFilters])

  const handleClick = () => {
    const filtersToReset = selectedStaticFiltersWithoutQuery.reduce<Partial<FilterModel>>(
      (params, filterName) => {
        if (filterName in initialFilterState) {
          return {
            ...params,
            [filterName as keyof FilterModel]: initialFilterState[filterName as keyof FilterModel],
          }
        }

        return params
      },
      {},
    )

    fetchDynamicFilters({
      selectedDynamicFilters: [],
      selectedFilters: filtersToReset,
    })
    fetchCatalogBrand({ selectedDynamicFilters: [] })
  }

  if (
    !selectedStaticFiltersWithoutQuery.length &&
    !selectedDynamicFilters.some(selectedFilter => {
      if (selectedFilter.ids.length) return true

      return false
    })
  )
    return null

  return (
    <Button
      onClick={handleClick}
      text={<FormattedMessage id="catalog.reset_filters" />}
      styling={Button.Styling.Flat}
      size={Button.Size.Small}
      testId="catalog-reset-filters-button"
    />
  )
}

export default FilterReset
